export * from './lib/UiKitInputPhoto';
